<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{ $t('form.search.legend') }}</legend>
          <ncs-select field="ncs_documents.subcorpus"/>
          <ncs-search-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{ $t('form.result.legend') }}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
            <div class="col-md-6 offset-md-3">
              <ncs-matching-expressions-group-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{ $t('form.sensibility.legend') }}</legend>
          <ncs-global-option-checkbox name="ncs_accent" :value="true"/>
          <ncs-global-option-checkbox name="case" :value="true"/>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{ $t('form.filters.legend') }}</legend>
          <div class="row">
            <div class="col-md-4">
              <ncs-select field="ncs_texts.grupo_edad"/>
            </div>
            <div class="col-md-4">
              <ncs-number-select-filter type="number" name="ncs_texts.edad_from" field="ncs_texts.edad"
                                        :min="15" :max="100" operator="gteq"/>
            </div>
            <div class="col-md-4">
              <ncs-number-select-filter type="number" name="ncs_texts.edad_to" field="ncs_texts.edad"
                                        :min="15" :max="100" operator="lteq" :reverse="true"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_texts.rol"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_texts.estudios"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_texts.sexo"/>
            </div>
            <div class="col-md-8">
              <ncs-multi-select field="ncs_texts.hablante" :searchable="true"
                                :dependencies="['ncs_texts.grupo_edad', 'ncs_texts.rol', 'ncs_texts.estudios', 'ncs_texts.sexo']"/>
            </div>
            <div v-show="elements === 'units'" class="col-md-4">
              <ncs-select field="ncs_units.searchable_info" operator="array_contains"/>
            </div>
            <div v-show="elements === 'tokens'" class="col-md-4">
              <ncs-select field="ncs_tokens.searchable_info" operator="array_contains"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end">
        <ncs-back-button/>
        <ncs-reset-button/>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-matching-expressions-result/>
      <ncs-context-result/>
    </ncs-result>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsForm,
    computed: mapState({
      elements: s => s.elements.type,
      resultType: s => s.api.resultType
    })
  }
</script>
<style lang="scss">
  @import "../scss/variables";

  legend {
    color: $primary;
    border-bottom: 1px solid $primary;
    font-size: 14px;
    margin-bottom: 5px;
  }

  label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 0.25rem;
  }
</style>
